import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const ActivityAreaSchema = Yup.object().shape({
  label: yupRequiredString,
})
